import React, { useRef } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Breadcrumb, Affix, Form } from "antd";
import { Link, useNavigate } from "react-router-dom";
import NotingForm from "./NotingForm";

export default function CreateNoting(props) {
  //   Refs
  const propertyFormRef = useRef(null);

  //   Antd
  const [form] = Form.useForm();

  //   Router
  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/import-customs-clearance/noting-assessment-examination");
  };

  const addIou = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
        >
          <Header
            title="Add Noting Assessment and Examination"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={1}
                  danger
                  onClick={() => discartForm()}
                >
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={2}
                  type="primary"
                  onClick={() => addIou()}
                >
                  Save
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <NotingForm
        ref={propertyFormRef}
        form={form}
      />
    </>
  );
}
